<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
  <line x1="9" y1="6" x2="19.5" y2="6" />
  <line x1="9" y1="12" x2="19.5" y2="12" />
  <line x1="9" y1="18" x2="19.5" y2="18" />
  <circle cx="4.75" cy="6" r="1" fill="currentColor" />
  <circle cx="4.75" cy="12" r="1" fill="currentColor" />
  <circle cx="4.75" cy="18" r="1" fill="currentColor" />
</svg>